module.exports = __webpack_public_path__ + "img/7_26@2x.fcda0369.png";